interface ProgressBarProps {
  value: number;
  color?: string;
}

export function ProgressBar({ value, color = 'bg-primary' }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div className="w-full h-1.5 bg-slate-200 rounded-full overflow-hidden">
      <div
        className={`h-full ${color} rounded-full transition-all`}
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}